import React, { useState, useEffect, useContext } from "react";
import { Container, Grid, Card, Typography, Box, Radio, Button as MuiButton, IconButton } from "@mui/material";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { axiosInstance } from "../component/Api/instance";
import { UserContext } from "../Context";
import { PageHeader } from "../component/ui/PageHeaders";
import { PrimaryButton, SecondaryButton } from "../component/ui/Buttons";
import { Dialog, DialogTitle, DialogContent, DialogActions, Paper } from "@mui/material";

import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CloseIcon from "@mui/icons-material/Close";
import ShareIcon from "@mui/icons-material/Share";

import Correct from "../asserts/Component 322 – 3.png";
import Rong from "../asserts/Component 26 – 5.png";
import Web from "../asserts/_x36__stroke.png";
import ScoreBoard from "../asserts/Score Board@2x.jpg";

const TestPageContainer = styled(Box)(({ theme }) => ({
  minHeight: "100vh",
  padding: "32px 0",
  backgroundColor: theme.palette.background.default,
}));

const QuestionCard = styled(Card)(({ theme }) => ({
  borderRadius: "24px",
  padding: "32px",
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  boxShadow: "none",
  minHeight: "550px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
}));

const SidebarCard = styled(Card)(({ theme }) => ({
  borderRadius: "24px",
  padding: "32px",
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  boxShadow: "none",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
}));

const OptionContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'selected'
})(({ theme, selected }) => ({
  display: "flex",
  alignItems: "center",
  padding: "16px 20px",
  borderRadius: "16px",
  border: `2px solid ${selected ? theme.palette.primary.main : theme.palette.divider}`,
  backgroundColor: selected ? `${theme.palette.primary.main}0D` : "transparent",
  marginBottom: "16px",
  cursor: "pointer",
  transition: "all 0.2s ease",
  "&:hover": {
    borderColor: selected ? theme.palette.primary.main : theme.palette.text.secondary,
    backgroundColor: selected ? `${theme.palette.primary.main}0D` : theme.palette.action.hover,
  },
}));

const ImageBox = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "16px",
  overflow: "hidden",
  backgroundColor: theme.palette.action.hover,
  padding: "16px",
  marginBottom: "24px",
  cursor: "zoom-in",
  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
}));

const PaletteButton = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== 'status' && prop !== 'selected'
})(({ theme, status, selected }) => {
  let bgColor = theme.palette.background.paper;
  let textColor = theme.palette.text.primary;
  let borderColor = theme.palette.divider;

  if (status === "answered") {
    bgColor = theme.palette.success.main;
    textColor = theme.palette.success.contrastText;
    borderColor = theme.palette.success.main;
  } else if (status === "skipped") {
    bgColor = theme.palette.error.main;
    textColor = theme.palette.error.contrastText;
    borderColor = theme.palette.error.main;
  }

  return {
    width: "42px",
    height: "42px",
    fontWeight: 700,
    fontSize: "0.9rem",
    backgroundColor: bgColor,
    color: textColor,
    border: `2px solid ${selected ? theme.palette.primary.main : borderColor}`,
    borderRadius: "50%",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: status ? bgColor : theme.palette.action.hover,
      opacity: 0.9,
    },
  };
});

const StatusIndicator = styled(Box)(({ theme, color }) => ({
  width: "16px",
  height: "16px",
  borderRadius: "50%",
  backgroundColor: color,
  display: "inline-block",
  marginRight: "8px",
}));

export default function TestPage() {
  const [selectedQuestionIndex, setSelectedQuestionIndex] = useState(0);
  const { sno } = useParams();
  const [questions, setQuestions] = useState([]);
  const [questionsNo, setQuestionsNo] = useState([]);
  const [responsecount, setResponsecount] = useState(null);
  const email = localStorage.getItem("userMail");
  const [questionStatus, setQuestionStatus] = useState([]);
  const { Endpoint } = useContext(UserContext);
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const [finish, setfinish] = useState(false);
  const [nextConfirmOpen, setNextConfirmOpen] = useState(false);
  const [selectedOptionIndex, setSelectedOptionIndex] = useState(null);
  const [selectedOption, setSelectedOption] = useState("");
  const [optionIndexMapping, setOptionIndexMapping] = useState({});
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [answer, setanswer] = useState(false);
  const [btn, setbtn] = useState(false);
  const [zoomImage, setZoomImage] = useState(false);

  useEffect(() => {
    fetchQuestionSno();
  }, []);

  useEffect(() => {
    if (questionsNo.length > 0) {
      fetchQuestions(questionsNo[selectedQuestionIndex].sno);
    }
  }, [questionsNo, selectedQuestionIndex]);

  const fetchQuestions = async (questionId) => {
    try {
      const res = await axiosInstance.post(`get/U_ViewDailyQuestion.php`, {
        userId: email,
        test_id: sno,
        question_id: questionId,
      });
      if (res.status === 200) {
        if (res.data.message === "timeout") {
          navigate("/signin");
        }
        setQuestions(res.data);
      }
    } catch (error) {
      console.error("Error fetching questions:", error);
    }
  };

  const fetchQuestionSno = async () => {
    try {
      const res = await axiosInstance.post(`get/U_ViewDailyQuestionCount.php`, {
        userId: email,
        test_id: sno,
      });
      if (res.status === 200) {
        if (res.data.message === "timeout") {
          navigate("/signin");
        }
        setQuestionsNo(res.data);
      }
    } catch (error) {
      console.error("Error fetching question numbers:", error);
    }
  };

  const registerDatas1 = async () => {
    try {
      const res = await axiosInstance.post(`get/U_DailyTestMark.php`, {
        userId: email,
        test_id: sno,
      });
      if (res.status === 200) {
        if (res.data.message === "timeout") {
          navigate("/signin");
        }
        if (Array.isArray(res.data)) {
          setResponsecount(res.data);
        }
      }
    } catch (err) {
      console.error("Error fetching data:", err);
    }
  };

  const registerDatatest = async (questionId) => {
    try {
      const res = await axiosInstance.post(`put/U_updateDailyTestAns.php`, {
        id: email,
        question_id: questionId,
        answer: selectedOption,
      });
      if (res.status === 200) {
        if (res.data.message === "timeout") {
          navigate("/signin");
        }
      }
    } catch (err) {
      console.error("Error updating answer:", err);
    }
  };

  const handleQuestionChange = async (index) => {
    if (index >= 0 && index < questionsNo.length) {
      const selectedSno = questionsNo[index].sno;
      fetchQuestions(selectedSno);
      setSelectedQuestionIndex(index);
      setanswer(false);
      setbtn(false);
      if (index === questionsNo.length - 1) {
        await registerDatatest(questionsNo[selectedQuestionIndex].sno);
      }
    }
  };

  const handlePrevQuestion = async () => {
    const prevIndex = selectedQuestionIndex - 1;
    if (prevIndex >= 0) {
      const selectedSno = questionsNo[prevIndex].sno;
      await registerDatatest(questionsNo[selectedQuestionIndex].sno);
      await fetchQuestions(selectedSno);
      setSelectedQuestionIndex(prevIndex);
      setanswer(false);
      setbtn(false);

      const prevSavedOption = selectedOptions[prevIndex] || "";
      setSelectedOption(prevSavedOption);
      setSelectedOptionIndex(optionIndexMapping[prevIndex] ?? null);
    }
  };

  const handleNextClick = () => {
    if (selectedOptionIndex === null) {
      setNextConfirmOpen(true);
    } else {
      handleNextQuestion();
    }
  };

  const handleNextQuestion = async () => {
    const nextIndex = selectedQuestionIndex + 1;
    if (nextIndex < questionsNo.length) {
      const selectedSno = questionsNo[nextIndex].sno;
      await registerDatatest(questionsNo[selectedQuestionIndex].sno);
      await fetchQuestions(selectedSno);
      setSelectedQuestionIndex(nextIndex);
      setanswer(false);
      setbtn(false);

      setSelectedOption(selectedOptions[nextIndex] || "");
      setSelectedOptionIndex(optionIndexMapping[nextIndex] ?? null);

      setQuestionStatus((prevStatus) => {
        const newStatus = [...prevStatus];
        newStatus[selectedQuestionIndex] = selectedOptions[selectedQuestionIndex]
          ? "answered"
          : "skipped";
        return newStatus;
      });
    } else if (nextIndex === questionsNo.length) {
      await registerDatatest(questionsNo[selectedQuestionIndex].sno);
      setQuestionStatus((prevStatus) => {
        const newStatus = [...prevStatus];
        newStatus[selectedQuestionIndex] = selectedOption ? "answered" : "skipped";
        return newStatus;
      });
    }
  };

  const handleSkipQuestion = async () => {
    setQuestionStatus((prevStatus) => {
      const newStatus = [...prevStatus];
      newStatus[selectedQuestionIndex] = "skipped";
      return newStatus;
    });
    await handleNextQuestion();
  };

  const handleOptionSelect = (optionIndex) => {
    const selectedOptionText = questions[0][`option${optionIndex}`];
    setSelectedOptionIndex(optionIndex);
    setSelectedOption(selectedOptionText);

    setSelectedOptions((prevOptions) => {
      const updatedOptions = [...prevOptions];
      updatedOptions[selectedQuestionIndex] = selectedOptionText;
      return updatedOptions;
    });

    setOptionIndexMapping((prevMapping) => ({
      ...prevMapping,
      [selectedQuestionIndex]: optionIndex,
    }));
  };

  const Show = () => {
    setanswer(!answer);
    setbtn(!btn);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const FinishTest = () => {
    setfinish(true);
  };

  const FinishTestClose = () => {
    setfinish(false);
    navigate("/hybrid");
  };

  const isImage = (url) => {
    return url && url.match(/\.(jpeg|jpg|gif|png|svg|webp|jfif)$/) != null;
  };

  useEffect(() => {
    if (optionIndexMapping[selectedQuestionIndex] !== undefined) {
      setSelectedOptionIndex(optionIndexMapping[selectedQuestionIndex]);
    } else {
      setSelectedOptionIndex(null);
    }
  }, [selectedQuestionIndex, optionIndexMapping]);

  return (
    <TestPageContainer>
      <Container maxWidth="xl">
        {questions.length > 0 ? (
          <Box>
            <PageHeader 
              title="Daily Test"
              subtitle={`Question Progress: ${selectedQuestionIndex + 1} of ${questionsNo.length}`}
              onBack={() => navigate("/hybrid")}
            />

            <Grid container spacing={4}>
              <Grid item xs={12} lg={8}>
                <QuestionCard>
                  <Box>
                    <Typography 
                      variant="h2" 
                      style={{ fontWeight: 700, marginBottom: "24px", lineHeight: 1.5 }}
                    >
                      {selectedQuestionIndex + 1}. {questions[0].questions}
                    </Typography>

                    {questions[0].image && (
                      <ImageBox onClick={() => setZoomImage(!zoomImage)}>
                        <img
                          src={`${Endpoint}/controllers/api/admin/upload/${questions[0].image}`}
                          alt="Question Graphic"
                          style={{
                            maxHeight: zoomImage ? "350px" : "180px",
                            maxWidth: "100%",
                            objectFit: "contain",
                            transform: zoomImage ? "scale(1.08)" : "scale(1)",
                            transition: "all 0.3s ease",
                          }}
                        />
                      </ImageBox>
                    )}

                    <Box style={{ marginTop: "16px" }}>
                      {[1, 2, 3, 4].map((optionIndex) => {
                        const optionText = questions[0][`option${optionIndex}`];
                        const isSelected = selectedOptionIndex === optionIndex;

                        return (
                          <OptionContainer
                            key={optionIndex}
                            selected={isSelected}
                            onClick={() => handleOptionSelect(optionIndex)}
                          >
                            <Radio
                              checked={isSelected}
                              value={optionIndex}
                              color="primary"
                              style={{ padding: "0 12px 0 0" }}
                            />
                            {isImage(optionText) ? (
                              <img
                                src={`${Endpoint}/controllers/api/admin/upload/${optionText}`}
                                alt={`Option ${optionIndex}`}
                                style={{ maxHeight: "70px", borderRadius: "8px" }}
                              />
                            ) : (
                              <Typography variant="body1" style={{ fontWeight: 550 }}>
                                {optionText}
                              </Typography>
                            )}
                          </OptionContainer>
                        );
                      })}
                    </Box>

                    <Box style={{ marginTop: "24px" }}>
                      <SecondaryButton onClick={Show} style={{ borderRadius: "12px" }}>
                        {btn ? "Hide Answer" : "Show Correct Answer"}
                      </SecondaryButton>

                      {answer && (
                        <Card 
                          style={{ 
                            marginTop: "16px", 
                            padding: "20px", 
                            backgroundColor: "rgba(37, 99, 235, 0.05)", 
                            border: "1px solid rgba(37, 99, 235, 0.15)",
                            borderRadius: "16px",
                            boxShadow: "none"
                          }}
                        >
                          <Typography variant="subtitle2" style={{ fontWeight: 700, color: "var(--color-primary)" }}>
                            Correct Answer:
                          </Typography>
                          {isImage(questions[0].answer) ? (
                            <img
                              src={`${Endpoint}/controllers/api/admin/upload/${questions[0].answer}`}
                              alt="Answer Image"
                              style={{ maxWidth: "150px", marginTop: "10px", borderRadius: "8px" }}
                            />
                          ) : (
                            <Typography variant="body1" style={{ marginTop: "8px", fontWeight: 600 }}>
                              {questions[0].answer}
                            </Typography>
                          )}
                        </Card>
                      )}
                    </Box>
                  </Box>

                  <Box style={{ display: "flex", gap: "12px", marginTop: "32px", flexWrap: "wrap" }}>
                    <SecondaryButton
                      disabled={selectedQuestionIndex === 0}
                      onClick={handlePrevQuestion}
                      startIcon={<ArrowBackIcon />}
                      style={{ height: "46px", borderRadius: "14px", minWidth: "120px" }}
                    >
                      Previous
                    </SecondaryButton>
                    <SecondaryButton
                      onClick={handleSkipQuestion}
                      style={{ height: "46px", borderRadius: "14px", minWidth: "100px" }}
                    >
                      Skip
                    </SecondaryButton>
                    <PrimaryButton
                      onClick={handleNextClick}
                      endIcon={<ArrowForwardIcon />}
                      style={{ height: "46px", borderRadius: "14px", minWidth: "140px" }}
                    >
                      Save & Next
                    </PrimaryButton>
                  </Box>
                </QuestionCard>
              </Grid>

              <Grid item xs={12} lg={4}>
                <SidebarCard>
                  <Box>
                    <Box style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "20px" }}>
                      <HelpOutlineIcon color="primary" />
                      <Typography variant="subtitle1" style={{ fontWeight: 700 }}>
                        Question Status
                      </Typography>
                    </Box>

                    <Box style={{ display: "flex", justifyContent: "space-between", marginBottom: "20px", flexWrap: "wrap", gap: "8px" }}>
                      <Box style={{ display: "flex", alignItems: "center" }}>
                        <StatusIndicator color="green" />
                        <Typography variant="caption" style={{ fontWeight: 600 }}>Answered</Typography>
                      </Box>
                      <Box style={{ display: "flex", alignItems: "center" }}>
                        <StatusIndicator color="red" />
                        <Typography variant="caption" style={{ fontWeight: 600 }}>Skipped</Typography>
                      </Box>
                    </Box>

                    <Box 
                      style={{ 
                        backgroundColor: "var(--color-background-secondary)", 
                        borderRadius: "16px", 
                        padding: "16px", 
                        maxHeight: "300px", 
                        overflowY: "auto", 
                        display: "flex", 
                        flexWrap: "wrap", 
                        gap: "12px" 
                      }}
                    >
                      {questionsNo.map((question, index) => (
                        <PaletteButton
                          key={index}
                          status={questionStatus[index]}
                          selected={selectedQuestionIndex === index}
                          onClick={() => handleQuestionChange(index)}
                        >
                          {index + 1}
                        </PaletteButton>
                      ))}
                    </Box>
                  </Box>

                  <Box style={{ marginTop: "40px" }}>
                    <PrimaryButton
                      onClick={handleClickOpen}
                      style={{
                        width: "100%",
                        height: "48px",
                        borderRadius: "16px",
                        background: "linear-gradient(135deg, #DC2626 0%, #B91C1C 100%)",
                        boxShadow: "0 4px 12px rgba(220, 38, 38, 0.2)",
                        fontWeight: 700,
                      }}
                    >
                      Finish Test
                    </PrimaryButton>
                  </Box>
                </SidebarCard>
              </Grid>
            </Grid>

            {/* Confirm Finish Dialog */}
            <Dialog open={open} onClose={handleClose}>
              <DialogTitle>Finish Test</DialogTitle>
              <DialogContent dividers>
                <Typography>Are you sure you want to finish the Test?</Typography>
                {(() => {
                  const answeredCount = Object.keys(optionIndexMapping).filter(
                    (key) => optionIndexMapping[key] !== null && optionIndexMapping[key] !== undefined
                  ).length;
                  const unansweredCount = questionsNo.length - answeredCount;
                  if (unansweredCount > 0) {
                    return (
                      <Typography color="error" style={{ marginTop: "10px", fontWeight: 600 }}>
                        Warning: You have {unansweredCount} unanswered questions.
                      </Typography>
                    );
                  }
                  return null;
                })()}
              </DialogContent>
              <DialogActions>
                <PrimaryButton 
                  onClick={() => {
                    handleClose();
                    FinishTest();
                    registerDatas1();
                  }}
                >
                  Yes, Finish Test
                </PrimaryButton>
                <SecondaryButton onClick={handleClose}>Cancel</SecondaryButton>
              </DialogActions>
            </Dialog>

            {/* Confirm Next Without Answer Dialog */}
            <Dialog open={nextConfirmOpen} onClose={() => setNextConfirmOpen(false)}>
              <DialogTitle>No Answer Selected</DialogTitle>
              <DialogContent dividers>
                <Typography>You have not selected an answer for this question. Do you want to proceed to the next question?</Typography>
              </DialogContent>
              <DialogActions>
                <SecondaryButton onClick={() => setNextConfirmOpen(false)}>Cancel</SecondaryButton>
                <PrimaryButton 
                  onClick={() => {
                    setNextConfirmOpen(false);
                    handleNextQuestion();
                  }}
                  color="warning"
                >
                  Proceed
                </PrimaryButton>
              </DialogActions>
            </Dialog>

            {/* Finish Score Dialog */}
            <Dialog open={finish} onClose={FinishTestClose}>
              <DialogTitle>Test Results</DialogTitle>
              <DialogContent dividers>
                <Typography style={{ fontWeight: 700, color: "green", marginBottom: "16px" }}>
                  Thank you, your test is submitted successfully.
                </Typography>
                {responsecount && responsecount.length > 0 ? (
                  responsecount.map((item, index) => (
                    <Box key={index} style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                      <Typography variant="body1">Correct Answer: <b>{item.correct_count}</b></Typography>
                      <Typography variant="body1">Wrong Answer: <b>{item.incorrect_count}</b></Typography>
                      <Typography variant="body1">Skipped: <b>{item.skip_count}</b></Typography>
                      <Typography variant="body1">Negative Mark: <b>{item.negative_marks}</b></Typography>
                      <Typography variant="body1">Total Mark: <b>{item.total_marks}</b></Typography>
                    </Box>
                  ))
                ) : (
                  <Typography>Loading scorecard details...</Typography>
                )}
              </DialogContent>
              <DialogActions style={{ display: "flex", justifyContent: "space-between", width: "100%", padding: "16px 24px" }}>
                <SecondaryButton 
                  onClick={() => {
                    if (responsecount && responsecount.length > 0) {
                      const score = responsecount[0]?.total_marks || 0;
                      const totalMarks = responsecount[0]?.total_questions || 0;
                      const shareText = `I scored ${score}/${totalMarks} in the Nursing Update Test!`;
                      const canvas = document.createElement("canvas");
                      const context = canvas.getContext("2d");
                      canvas.width = 800;
                      canvas.height = 450;

                      const image = new Image();
                      image.src = ScoreBoard;
                      image.onload = () => {
                        context.drawImage(image, 0, 0, canvas.width, canvas.height);
                        context.font = "30px Arial";
                        context.fillStyle = "black";
                        context.textAlign = "right";

                        const lines = shareText.split(" Nursing ");
                        context.fillText(lines[0], canvas.width / 2, canvas.height / 2 - 20);
                        context.fillText("Nursing Update Test!", canvas.width / 2, canvas.height / 2 + 20);

                        canvas.toBlob((blob) => {
                          const imageUrl = URL.createObjectURL(blob);
                          navigator.clipboard.writeText(shareText).then(() => {
                            if (window.confirm("Score copied to clipboard! Click OK to share the image on Instagram.")) {
                              const link = document.createElement("a");
                              link.href = imageUrl;
                              link.download = "score-image.png";
                              link.click();
                              window.open("https://www.instagram.com/", "_blank");
                            }
                          });
                        }, "image/png");
                      };
                    }
                  }}
                  startIcon={<ShareIcon />}
                  style={{ minWidth: "150px" }}
                >
                  Share Score
                </SecondaryButton>
                <PrimaryButton onClick={FinishTestClose}>Done</PrimaryButton>
              </DialogActions>
            </Dialog>
          </Box>
        ) : (
          <Typography align="center" style={{ marginTop: "100px" }}>Loading exam question data...</Typography>
        )}
      </Container>
    </TestPageContainer>
  );
}
